import { api } from "@/services/api"
import type { UpdateDiagnosticsParams } from "@/services/api/odin/activities/diagnostic/update"
import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

export function useUpdateDiagnostic() {
  return useMutation({
    mutationKey: ["update-diagnostic"],
    mutationFn: (params: UpdateDiagnosticsParams) => api.odin.activities.diagnostic.update(params),
    onSuccess: () => {
      toast.success("Actividad editada con éxito")
    },
    onError: () => {
      toast.error(
        "¡Ups! No se pudo editar la actividad. Intentalo de nuevo y, si el error persiste, contactanos.",
      )
    },
  })
}
